export default function Briefcase(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M24.2807 32.132V7.0084C24.2807 5.27395 22.8746 3.86792 21.1402 3.86792H14.8592C13.1248 3.86792 11.7188 5.27395 11.7188 7.0084V32.132"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.43736 10.1489H30.5609C30.5609 10.1489 33.7014 10.1489 33.7014 13.2893V28.9915C33.7014 28.9915 33.7014 32.132 30.5609 32.132H5.43736C5.43736 32.132 2.29688 32.132 2.29688 28.9915V13.2893C2.29688 13.2893 2.29688 10.1489 5.43736 10.1489Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
